import { Badge } from '@ds/core';

export interface VisorDeDocumentoProps {
    titulo: string;
    corpo: string;
    /** "Paciente + profissional" desenha duas linhas de assinatura. */
    assinantes?: string;
    etiquetas?: { texto: string; tom: 'brand' | 'info' | 'neutral' | 'success' | 'warning' | 'danger' }[];
    apoio?: string;
}

/**
 * O documento como ele é lido — texto corrido e as linhas de assinatura.
 *
 * Serve a pré-visualização do modelo e a leitura do documento emitido: o que
 * muda entre os dois é só de onde vem o texto, e ver a mesma folha nos dois
 * lugares é o que dá confiança de que o que sai é o que se viu.
 */
export function VisorDeDocumento({ titulo, corpo, assinantes, etiquetas = [], apoio }: VisorDeDocumentoProps) {
    const linhas = assinantes && assinantes !== 'Não requer assinatura' ? assinantes.split(' + ') : [];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {(etiquetas.length > 0 || apoio) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    {etiquetas.map((e) => <Badge key={e.texto} tone={e.tom} dot>{e.texto}</Badge>)}
                    {apoio && <span style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>{apoio}</span>}
                </div>
            )}

            <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', padding: 24, maxHeight: 320, overflowY: 'auto' }}>
                <p style={{ margin: '0 0 16px', fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em' }}>{titulo}</p>
                {/* `pre-wrap` porque o corpo é texto do modelo, com as quebras
                    que quem escreveu colocou — reflow perderia a lista de itens. */}
                <p style={{ margin: 0, fontSize: 13, lineHeight: '21px', color: 'var(--text-body)', whiteSpace: 'pre-wrap' }}>{corpo}</p>

                {linhas.length > 0 && (
                    <div style={{ display: 'flex', gap: 32, marginTop: 32 }}>
                        {linhas.map((quem) => (
                            <span key={quem} style={{ flex: 1 }}>
                                <span style={{ display: 'block', height: 1, background: 'var(--border-strong)', marginBottom: 6 }} />
                                <span style={{ fontSize: 11.5, color: 'var(--text-tertiary)' }}>{quem}</span>
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
